import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Heading } from '@marvelapp/ui';
export default function ShareHeading({ addMarginBottom, children }) {
    return (_jsx(Box, { borderBottom: "1px solid", borderColor: "smoke", mb: addMarginBottom && 5, pb: 4, children: _jsx(Heading, { children: children }) }));
}
